const TopShape01 = () => {

    return (<div className="rmdr-top-shape-01" />)

}

export default TopShape01;
